import React from 'react'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import Share from '../../components/share'
import styles from './styles'

const Lead = withStyles(styles)(props => {
  const { classes, title, published, author, suptitle, lead, tags, hideSocial = false } = props
  return (
    <div className={classes.contents}>
      <div className={classes.lead}>
        <Grid container spacing={40}>
          <Grid item xs={12}>
            {
              tags && tags.map((tag, index) => {
                return <Chip key={index} label={tag} className={classes.tag}/>
              })
            }
          </Grid>
        </Grid>
        <Grid container spacing={40}>
          <Grid item xs={12}>
            {
              !hideSocial &&
              <div className={classes.share}>
                <Share
                  shareUrl={
                    typeof document !== 'undefined' && document.location.href
                  }
                  title={title}
                />
              </div>
            }
            <div style={{ display: 'inline', maxWidth: '100%'}}>
            {
              suptitle &&
              <Typography className={classes.suptitle} gutterBottom>
                {suptitle.text}
              </Typography>
            }
            <Typography className={classes.head} gutterBottom>
              {title.text}
            </Typography>
            {author && author.name && (
              <Typography variant="caption" className={classes.author}>
                {author.name.text}
              </Typography>
            )}
            <Typography variant="caption" gutterBottom={true}>
              {published}
            </Typography>
            </div>
            {
              lead && lead.text &&
              <Typography className={classes.text}>{lead.text}</Typography>
            }
          </Grid>
        </Grid>
      </div>
    </div>
  )
})

export default withStyles(styles)(Lead)



// WEBPACK FOOTER //
// ./src/components/lead/index.js